import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  background: ${({ bg }) => bg};
  color: ${({ fontColor }) => fontColor};
  display: flex;
  /* justify-content: center; */
  flex-direction: column;
  align-items: center;

  img {
    @media all and (max-width: 567px) {
      display: none;
    }
  }
  .wrapper {
    width: 100%;
    margin: 8.5rem 9rem;
    margin-bottom: 0;
    text-align: center;
    @media all and (max-width: 567px) {
      margin: 5rem 2rem;
    }

    .header {
      span {
        font-size: 1.4rem;
        /* line-height: 1.7rem; */
        letter-spacing: 0.15em;
      }
      .title {
        font-size: 3.6rem;
        /* line-height: 4.5rem; */
        margin-top: 1.2rem;
        margin-bottom: 6.4rem;
      }
    }

    .content {
      display: flex;
      flex-wrap: wrap;
      text-align: left;
      justify-content: space-evenly;
      width: 100%;

      .card {
        padding: 6rem 5.4rem;
        border: 1px solid rgba(248, 241, 255, 0.4);
        border-radius: 12px;
        background: rgba(218, 180, 255, 0.1);
        margin: 5px;

        @media all and (max-width: 567px) {
          padding: 5rem 2rem;
        }
        span {
          margin-bottom: 12px;
          letter-spacing: 0.15em;
        }
        .card-header {
          font-size: 2.4rem;
          line-height: 3rem;
          max-width: 396px;
          margin: 12px 0;
        }
        .desc {
          font-size: 1.5rem;
          line-height: 2.8rem;
          max-width: 396px;
          margin: 8px 0;
        }

        .more-btn {
          background: transparent;
          margin: 2.4rem 0;
          font-size: 1.6rem;
          font-weight: 300;
          a {
            display: flex;
            align-items: center;
            text-decoration: none;
            color: rgba(181, 206, 255, 1);
          }

          svg {
            margin: 0 8px;
            transition: 0.25s;
          }
          :hover {
            svg {
              width: 30px;
            }
          }
        }
      }
    }
  }
`;
